module.exports = __webpack_public_path__ + "img/logo-led.81410750.png";